module.exports = __webpack_public_path__ + "img/Sign-in-Ar.7dbf76c2.svg";